import * as React from "react";

// Import layout
import Layout from "../layouts/main";

// Import components
import Intro from "../components/intro";
import Products from "../components/products";
import SEO from "../components/seo";

// Import styles
import "./styles/index.scss";
import "../assets/fonts/fonts.css";

// Import assets
import image from "../assets/images/og-image.jpg";

const IndexPage = () => {
  return (
    <Layout>
      <SEO
        title="The Lisa Mae"
        description="Abstract flower art - digital & design creative, Denver, CO."
        image={`https://thelisamae.netlify.com${image}`}
      />
      <div className="homepage">
        <Intro />
        <Products />
      </div>
    </Layout>
  );
};

export default IndexPage;
